import { render } from "./TournamentAdvancedMatchSetRoundsMode.vue?vue&type=template&id=69115da4&ts=true"
import script from "./TournamentAdvancedMatchSetRoundsMode.vue?vue&type=script&lang=ts"
export * from "./TournamentAdvancedMatchSetRoundsMode.vue?vue&type=script&lang=ts"

import exportComponent from "/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__